module.exports = __webpack_public_path__ + "img/Harlekin.ebf2ddf0.jpg";